import { OrderInvoicePrinting } from './OrderInvoicePrinting';

import { orderToPrintService } from './infra';

import type { OrderIdForcedProps } from './domain';

// Use this component to force the printing of an order invoice
export function ForceOrderInvoicePrinting(props: OrderIdForcedProps) {
  const { orderIdForced = NaN } = props;
  const { isRenderForced } = orderToPrintService(props);
  return (
    <>
      {isRenderForced && (
        <aside
          aria-label='ForceOrderInvoicePrinting'
          style={{
            width: '73mm', // simulate real space and width of the paper
            height: 'inherit',
            margin: '2rem 0.5rem',
            border: '2px solid black',
          }}
        >
          <OrderInvoicePrinting orderIdForced={orderIdForced} />
        </aside>
      )}
    </>
  );
}
